import Vue from 'vue'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: { customProperties: true },
    themes: {
      primacy: {
        anchor: '#2196f3',
        primary: '#9c27b0',
        secondary: '#673ab7',
        accent: '#607d8b',
        error: '#f44336',
        warning: '#ff9800',
        info: '#009688',
        success: '#4caf50'
      },
      // dark: {
      //   anchor: '#2196f3',
      //   primary: '#ca87d7',
      // },
      // light: {
      //   anchor: '#2196f3',
      //   primary: '#9c27b0',
      // }
    }
  },
}

/*
import colors from 'vuetify/es5/util/colors'

      {
      primary: colors.purple.base,
      secondary: colors.deep-purple.base,
      accent: colors.blue-grey.base,
      error: colors.red.base,
      warning: colors.orange.base,
      info: colors.teal.base,
      success: colors.green.base
      }
 */

export default new Vuetify(opts)
